/* eslint-disable camelcase */
export const FEE_RATES = {
    default_120: 0.0589,
    default_15: 0.0106,
    default_30: 0.0151,
    default_60: 0.0298,
    default_90: 0.0437,
    no_finance: 0,
};
/* eslint-enable camelcase */ 
